<div class="animated-bg">
    <div class="blob blob-1"></div>
    <div class="blob blob-2"></div>
    <div class="blob blob-3"></div>
</div>

<div class="wave-container">
    <svg class="wave-svg" viewBox="0 0 1440 180" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <path class="wave-path-2" d="M0,100 C320,160 640,40 960,80 C1200,112 1320,140 1440,100 L1440,180 L0,180 Z" />
        <path class="wave-path" d="M0,120 C240,80 480,160 720,120 C960,80 1200,160 1440,120 L1440,180 L0,180 Z" />
    </svg>
</div>

<div class="transition-layer" aria-hidden="true">
    <svg width="0" height="0">
        <filter id="goo">
            <feGaussianBlur stdDeviation="18" />
            <feColorMatrix values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 24 -12" />
        </filter>
    </svg>
    <div class="sky-glow"></div>
    <div class="speed-lines"></div>
    <div class="cloud-bank">
        <div class="cloud c1"></div>
        <div class="cloud c2"></div>
        <div class="cloud c3"></div>
        <div class="cloud c4"></div>
    </div>
    <div class="contrail"></div>
    <div class="plane-wrap">
        <svg class="plane" viewBox="0 0 220 120">
            <path fill="currentColor" d="M207 53c-5-6-13-9-22-9l-58-1L85 7 67 8l21 36-50 5L19 32 7 34l14 29 67 8-25 40 20 2 45-40 58 3c16 1 29-5 30-13 1-4-3-8-9-10Z" />
            <path class="plane-shine" d="m128 49 58 1c10 0 17 3 21 7-10-2-25-2-40-1l-45 2Z" />
            <path class="plane-window" d="M104 44 86 18l10-1 29 27Z" />
        </svg>
    </div>
    <div class="wipe"></div>
</div>

<div class="login-card-wrapper flex items-center justify-center min-h-screen px-4 py-8">
    <div class="w-full max-w-md">
        <div class="glass-card rounded-3xl px-6 sm:px-10 py-10 flex flex-col items-center">
            @if (logoPath) {
                <img [src]="logoPath" alt="logo" class="mb-6" style="height: 60px;" />
            }

            <div class="flex flex-col items-center mb-8">
                <h1 class="text-surface-900 dark:text-surface-0 font-bold text-2xl">Sign In</h1>
                <p class="text-surface-500 dark:text-surface-400 text-sm mt-1">Enter your credentials to continue</p>
            </div>

            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="w-full flex flex-col gap-5" novalidate>
                @if (errorMessage()) {
                    <p-message severity="error" [text]="errorMessage()" styleClass="w-full" />
                }

                <div class="flex flex-col gap-2">
                    <label for="username" class="text-sm font-medium text-surface-700 dark:text-surface-200">Username</label>
                    <input
                        pInputText
                        id="username"
                        type="text"
                        formControlName="username"
                        aria-describedby="username-error"
                        class="w-full"
                        autocomplete="username"
                        placeholder="Enter your username"
                    />
                    @if (loginForm.controls.username.touched && loginForm.controls.username.invalid) {
                        <small id="username-error" class="text-red-500 text-sm">Username is required.</small>
                    }
                </div>

                <div class="flex flex-col gap-2">
                    <label for="password" class="text-sm font-medium text-surface-700 dark:text-surface-200">Password</label>
                    <p-password
                        inputId="password"
                        formControlName="password"
                        [feedback]="false"
                        [toggleMask]="true"
                        styleClass="w-full"
                        inputStyleClass="w-full"
                        aria-describedby="password-error"
                        autocomplete="current-password"
                        placeholder="Enter your password"
                    />
                    @if (loginForm.controls.password.touched && loginForm.controls.password.invalid) {
                        <small id="password-error" class="text-red-500 text-sm">Password is required.</small>
                    }
                </div>

                @if (showRecaptcha()) {
                    <div class="flex flex-col gap-2">
                        <div #recaptchaContainer class="recaptcha-container"></div>
                        @if (loginForm.controls.password.touched && !recaptchaVerified()) {
                            <small class="text-red-500 text-sm">Please complete the reCAPTCHA verification.</small>
                        }
                    </div>
                }

                <p-button type="submit" label="Sign In" [loading]="loading()" styleClass="w-full" [disabled]="loading()" />

                <a [href]="forgotPasswordUrl" class="text-center text-sm text-primary hover:underline mt-1">Forgot / Reset Password</a>
            </form>

            @if (companyName && companyName !== '-') {
                <span class="text-surface-400 dark:text-surface-500 text-xs mt-8">{{ companyName }}</span>
            }
        </div>
    </div>
</div>
